import React, { createContext, useContext, useMemo, useState } from "react";
import { resolveParticipantRole, ROLE_CANDIDATE } from "./participantRole";

const LiveKitSessionContext = createContext({
  accessToken: null,
  telemetryJwt: null,
  setTelemetryJwt: () => {},
  // TI-735: integrity-service service JWT, minted server-side alongside the telemetry token.
  integrityJwt: null,
  setIntegrityJwt: () => {},
  // TI-1099: 'candidate' | 'recruiter', read from the signed join token. Defaults to
  // candidate so a consumer outside the provider keeps the pre-TI-1099 behaviour.
  participantRole: ROLE_CANDIDATE,
});

export function LiveKitSessionProvider({ accessToken, children }) {
  const [telemetryJwt, setTelemetryJwt] = useState(null);
  const [integrityJwt, setIntegrityJwt] = useState(null);
  // Derived from the token rather than stored: it changes only when the token does, and it
  // must never drift out of sync with the credential the room actually joined with.
  const participantRole = useMemo(() => resolveParticipantRole(accessToken), [accessToken]);
  const value = useMemo(
    () => ({
      accessToken,
      telemetryJwt,
      setTelemetryJwt,
      integrityJwt,
      setIntegrityJwt,
      participantRole,
    }),
    [accessToken, telemetryJwt, integrityJwt, participantRole]
  );
  return (
    <LiveKitSessionContext.Provider value={value}>
      {children}
    </LiveKitSessionContext.Provider>
  );
}

export function useLiveKitSession() {
  return useContext(LiveKitSessionContext);
}
